// Sample data to fill the activityTypes table on creation
const initialActivityTypesData = [
  {
    title: 'Biking'
  },
  {
    title: 'Walking'
  },
  {
    title: 'Jogging'
  },
  {
    title: 'Hiking'
  },
  {
    title: 'Swimming'
  },
  {
    title: 'Skating'
  },
  {
    title: 'Rowing'
  }
]

export default initialActivityTypesData
